"use client";

import { c as _c } from "react/compiler-runtime";
import type { LandingSection } from "@growwithai/shared";
import SandboxedHtmlFrame from "@/components/common/SandboxedHtmlFrame";
type CustomHtmlData = Extract<LandingSection, {
  type: "custom_html";
}>;

/**
 * Section HTML+JS penuh buatan admin (mis. hasil generate AI). Keamanan &
 * auto-height ditangani SandboxedHtmlFrame (iframe sandbox tanpa
 * allow-same-origin) — lihat komponen itu untuk detail.
 */
export default function CustomHtmlSection(t0) {
  const $ = _c(4);
  const {
    section
  } = t0;
  const t1 = section.height_mode ?? "auto";
  let t2;
  if ($[0] !== section.height_px || $[1] !== section.html || $[2] !== t1) {
    t2 = <section className="w-full"><SandboxedHtmlFrame html={section.html} heightMode={t1} heightPx={section.height_px} /></section>;
    $[0] = section.height_px;
    $[1] = section.html;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}